import angular from 'angular';
import uiRouter from 'angular-ui-router';
import listComponent from './list.component';

let floraModule = angular.module('list', [
  uiRouter
])

.config(($stateProvider) => {
  "ngInject";
  $stateProvider
  .state('dashboard.list', {
    url: '/list/:modelEnum',
    component: 'resourceList',
    params: {
      modelEnum : null
    }
  });
})

.component('resourceList', listComponent)

.name;

export default floraModule;



// WEBPACK FOOTER //
// ./client/app/components/dashboard/list/list.js